module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote5.b6d484be.svg";